export enum AuthError {
  USER_EXISTS,
  UNKNOWN,
}
